import { gql } from '@apollo/client'
import { AddNewProductTypeInputFragment } from '../fragments/addExtistingProductType.fragments'
import { DTVFragment } from '../fragments/dtv.fragments'
import { ProjectItemFragments } from '../fragments/projectItem.fragments'
import { getChildElementQuery } from '../queries/projectElements.queries'

export const AddUniformatClassificationToProjectMutation = gql`
    mutation addUniformatClassificationToProject($input: CreateElementInput!) {
        addUniformatClassificationToProject(input: $input) {
            projectElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                isDeactivated
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isProjectOnly
                isBpPublished
            }
        }
    }
`
export const AddContentGroupToProjectMutation = gql`
    mutation addContentGroupToProject($input: CreateContentGroupElementInput!) {
        addContentGroupToProject(input: $input) {
            projectElementNodes {
                id
                elementId
                baseElementId
                isInProject
                isDeactivated
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isBpPublished
            }
        }
    }
`

export const RemoveContentGroupFromProjectMutation = gql`
    mutation removeProductFamilyFromProject(
        $input: RemoveProjectElementInput!
    ) {
        removeContentGroupFromProject(input: $input) {
            removedElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                isImportedToProject
                isBpPublished
                importedToProjectId
                isBasedFromImportedNode
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
            }
            deletedElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                isImportedToProject
                isBpPublished
                importedToProjectId
                isBasedFromImportedNode
                hasChildren
                isLastSubAssembly
                isProjectOnly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
            }
            parentElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isProjectOnly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isBpPublished
            }
        }
    }
`
export const AddProductFamilyToProjectMutation = gql`
    mutation addProductFamilyToProject($input: CreateElementInput!) {
        addProductFamilyToProject(input: $input) {
            projectElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                isDeactivated
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isProjectOnly
                isBasedFromManufacturerOption
                isBpPublished
                isSpecTextNode
                attachedToFirmId
                iteration {
                    id
                    name
                }
            }
        }
    }
`

export const CreateBulkFamilyIterationWorkItemsMutation = gql`
    mutation createBulkFamilyIterationWorkItems(
        $input: CreateBulkFamilyIterationOMWorkItemsInput!
    ) {
        createBulkFamilyIterationWorkItems(input: $input) {
            projectElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                isDeactivated
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isProjectOnly
                isBasedFromManufacturerOption
                isBpPublished
                attachedToFirmId
                isPrimaryIteration
                iteration {
                    id
                    name
                }
            }
        }
    }
`
export const CreateWorkItemFromBaseMasterSpecFamily = gql`
    mutation createCloneAndWorkItemInOMFromBaseMasterSpecFamily(
        $input: OMCreateWorkItemOutOfBaseMasterSpecInput!
    ) {
        createCloneAndWorkItemInOMFromBaseMasterSpecFamily(input: $input) {
            instanceId
        }
    }
`

export const AddNuggetToProjectMutation = gql`
    mutation addNuggetToProject($input: CreateElementInput!) {
        addNuggetToProject(input: $input) {
            projectElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                isDeactivated
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isBpPublished
                isSpecTextNode
                isProjectOnly
                isBasedFromManufacturerOption
                iteration {
                    id
                    name
                }
            }
        }
    }
`

export const DuplicateProductTypeMutation = gql`
    mutation duplicateProductType($input: DuplicateProductTypeInput!) {
        duplicateProductType(input: $input) {
            newNode {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isProjectOnly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isBasedFromManufacturerOption
            }
            newNodesForAdditionalInstances {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isProjectOnly
                isBasedFromManufacturerOption
            }
        }
    }
`

export const RemoveUniformatClassificationFromProjectMutation = gql`
    mutation removeUniformatClassificationFromProject(
        $input: RemoveProjectElementInput!
    ) {
        removeUniformatClassificationFromProject(input: $input) {
            removedElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isProjectOnly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
            }
            deletedElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isProjectOnly
                isBpPublished
            }
            parentElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                isBpPublished
                importedToProjectId
                isBasedFromImportedNode
                isProjectOnly
            }
        }
    }
`

export const UpdateProjectUniformatClassificationElementMutation = gql`
    mutation updateProjectUniformatClassificationElement(
        $input: UpdateElementInput!
    ) {
        updateProjectUniformatClassificationElement(input: $input) {
            id
            name
            dataType
            projectElementMetadata {
                assignedUser
                baseElementId
                currentLOD
                projectId
                state
                targetLOD
            }
        }
    }
`
export const AddNewProductTypeInputMutation = gql`
    mutation addNewProductType($input: AddNewProductTypeInput!) {
        addNewProductType(input: $input) {
            newNode {
                ...addNewProductType

                hasBestPractice
            }
            newNodesForAdditionalInstances {
                ...addNewProductType
            }
        }
    }
    ${AddNewProductTypeInputFragment}
`

export const AddNewProductTypeMutation = gql`
    mutation createProductType($input: CreateProductTypeInput!) {
        createProductType(input: $input) {
            newNode {
                ...addNewProductType

                hasBestPractice
            }
            newNodesForAdditionalInstances {
                ...addNewProductType
            }
        }
    }
    ${AddNewProductTypeInputFragment}
`

export const UpdateProjectProductFamilyElementMutation = gql`
    mutation updateProjectProductFamilyElement($input: UpdateElementInput!) {
        updateProjectProductFamilyElement(input: $input) {
            id
            name
            dataType
            projectElementMetadata {
                assignedUser
                baseElementId
                currentLOD
                projectId
                state
                targetLOD
                isTargetLevelOfSpecificationManuallyUpdated
            }
        }
    }
`

export const RemoveProductFamilyFromProjectMutation = gql`
    mutation removeProductFamilyFromProject(
        $input: RemoveProjectElementInput!
    ) {
        removeProductFamilyFromProject(input: $input) {
            removedElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isProjectOnly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isBasedFromManufacturerOption
                isBpPublished
            }
            deletedElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isProjectOnly
                isBasedFromManufacturerOption
                isBpPublished
            }
            parentElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isProjectOnly
                isBasedFromManufacturerOption
                isBpPublished
            }
        }
    }
`

export const ClearBulkFamilyIterationWorkItemsMutation = gql`
    mutation clearBulkFamilyIterationWorkItems(
        $input: OfficeMasterRemoveBulkWorkItemsInput!
    ) {
        clearBulkFamilyIterationWorkItems(input: $input) {
            removedElementNodes {
                ...projectElementNodes
            }
            deletedElementNodes {
                ...projectElementNodes
            }
            parentElementNodes {
                ...projectElementNodes
            }
        }
    }
    ${ProjectItemFragments.ProjectElementNodes}
`

export const RemoveNuggetFromProjectMutation = gql`
    mutation removeNuggetFromProject($input: RemoveProjectElementInput!) {
        removeNuggetFromProject(input: $input) {
            removedElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                isHidden
                parentTreePath
                projectId
                isSearchResult
                hasChildren
                isLastSubAssembly
                isImportedToProject
                isBasedFromImportedNode
                importedToProjectId
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isProjectOnly
                isBasedFromManufacturerOption
                isBpPublished
            }
            deletedElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isProjectOnly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isBasedFromManufacturerOption
                isBpPublished
            }
            parentElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isProjectOnly
                isBasedFromManufacturerOption
                isBpPublished
            }
        }
    }
`

export const UpdatePropertyValuesForUniformatClassificationMutation = gql`
    mutation updatePropertyValuesForUniformatClassification(
        $input: UpdatePropertiesForPUCInput!
    ) {
        updatePropertyValuesForUniformatClassification(input: $input) {
            name
            id
            uniformatClassificationProperties {
                hint
                id
                name
                value
                units
                uniformatClassificationId
            }
        }
    }
`

export const UpdateProjectNuggetElementMutation = gql`
    mutation updateProjectNuggetElement($input: UpdateElementInput!) {
        updateProjectNuggetElement(input: $input) {
            id
            name
            dataType
            projectElementMetadata {
                assignedUser
                baseElementId
                currentLOD
                projectId
                state
                targetLOD
            }
        }
    }
`

export const SetDrawingDesignation = gql`
    mutation($input: UpdateNuggetElementInput!) {
        setDrawingDesignation(input: $input)
    }
`

export const AddNewProductTypeContentItem = (depth: number) => {
    const elements = getChildElementQuery(depth)
    return gql`
        mutation addNewProductTypeContentItem(
            $input: AddProjectContentItemInput!
            $nodeId: String!
            $rootArticleContentItemIds: [String],
            $productFamilyId: String!,
            $partType: TemplateItemPartType!,
            $projectId: String!
            $isTrackChangeToggleOn: Boolean
        ) {
            addProjectContentItem(input: $input, isTrackChangeToggleOn: $isTrackChangeToggleOn) {
                projectNuggets {
                    id
                    projectProductTypeProperties {
                        id
                        name
                    }
                    projectElementMetadata {
                        baseElementId
                    }
                    projectProductTypePropertiesView(nodeId: $nodeId, 
                        isTrackChangeToggleOn: $isTrackChangeToggleOn) {
                        ...dtvFragment
                    }
                }
                contentItemNodes (input: {
                    templateItemPartType: $partType,
                    rootArticleContentItemId: $rootArticleContentItemIds
                    productFamilyId: $productFamilyId
                    projectId: $projectId
                }) {
                    id
                    comments
                    textType
                    isBestPractice
                    isGlobalBestPractice
                    ${elements}
                }
                
            }
        }
        ${DTVFragment}
    `
}

export const DeleteProductTypeMutation = gql`
    mutation deleteProductType($input: DeleteProductTypeInput!) {
        deleteProductType(input: $input) {
            baseElementId
            nestedBaseElementIds
        }
    }
`

export const AddBulkItemsToProjectMutation = gql`
    mutation projectBulkAdd($input: [CreateElementInput]!) {
        projectBulkAdd(input: $input) {
            projectElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                isDeactivated
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isProjectOnly
            }
        }
    }
`

export const UpdateEditingTime = gql`
    mutation updateEditingTime($input: UpdateEditingTimeInput!) {
        updateEditingTime(input: $input)
    }
`

export const UpdateProjectFamilyIterationMutation = gql`
    mutation updateProjectFamilyIteration(
        $input: UpdateProjectFamilyIterationsInput!
    ) {
        updateProjectFamilyIteration(input: $input) {
            ...projectElementNodes
        }
    }
    ${ProjectItemFragments.ProjectElementNodes}
`
